import React, { useState, useEffect } from "react";
import MUIModal from "../../components/MUIModal";
import { useForm } from "react-hook-form";
import Invoices from "../../components/UI/MakePayment/pdf/invoice/invoices";
import { formatDate } from "../../utils/dateUtils";
import globalUtils from "../../utils/globalUtils";
import LoadInvoice from "../BrokerPayments/LoadInvoice";

import Invoice from "../../components/LoadDocuments/Invoice";
import { useGetMeQuery } from "../../services/user";
import {
	useLazyGetDispatchedLoadsQuery,
	useLazyGetLoadCountsAccQuery,
	useLazyGetLoadTotalRateQuery,
	useUpdateOrderMutation,
} from "../../services/load";
import { config } from "../../config";
import axios from "axios";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import { useLazyGetSingleOrganizationQuery } from "../../services/organization";
import { setBackDropOpen } from "../../store/slice/globalSlice";
import { Button, ButtonGroup } from "@mui/material";
import { toast } from "react-toastify";

const InvoicesSection = ({ showModal, setShowModal, loads, customerData, setDeleteIds }) => {
	const [triggerLoads] = useLazyGetDispatchedLoadsQuery();
	const { data: userData } = useGetMeQuery();
	const [triggerLoadsCount] = useLazyGetLoadCountsAccQuery();
	const [showModalPaid, setShowModalPaid] = useState(false);
	const [updateLoad] = useUpdateOrderMutation();
	const lastLoadsQuery = useSelector((state) => state.global.lastLoadsQueryBroker);

	const {
		register,
		watch,
		handleSubmit,
		setValue,
		control,
		setError,
		formState: { errors },
	} = useForm();

	const dispatch = useDispatch();

	const [getOrgById, { data: organizationData }] = useLazyGetSingleOrganizationQuery();

	const loadsActiveFilter = useSelector((state) => state.global.brokerActiveFilter);

	const { data: user } = useGetMeQuery();

	const [triggerTotalRateBackend] = useLazyGetLoadTotalRateQuery();
	const [triggerTotalRate] = useLazyGetLoadTotalRateQuery();

	const [currentLoad, setCurrentLoad] = useState({ ...loads[0], index: 0 });

	useEffect(() => {
		if (user) getOrgById(user.user.organization, true);
	}, [user]);

	useEffect(() => {
		if (loads && organizationData && customerData) {
			dispatch(setBackDropOpen(false));
			loads.forEach((load, index) => {
				setValue(`_id_${index}`, load._id);
				setValue(`address_1_${index}`, organizationData.address1);
				setValue(`orgName_${index}`, organizationData.companyName);
				setValue(`address_2_${index}`, organizationData.cityStateZip || "");
				setValue(`docket_${index}`, organizationData.mcNumber || "");
				setValue(`phone_${index}`, organizationData.phone || "");
				setValue(`loadId_${index}`, load.loadId);
				setValue(`load_date_${index}`, formatDate(new Date()));
				setValue(`load_reference_${index}`, load.referenceNumber);
				setValue(`weight_${index}`, `${globalUtils.getLoadWeight(load)} lbs`);
				setValue(`company_name_${index}`, customerData[index].customerName);
				setValue(`company_address_${index}`, customerData[index].customerAddress);
				setValue(`company_phone_${index}`, customerData[index].customerNumber);
				setValue(`paytm_description_${index}`, "Flat Rate");
				setValue(`paytm_notes_${index}`, load.notesPrivate);
				setValue(`paytm_quantity_${index}`, 1);
				setValue(`paytm_rate_${index}`, 1 * load.customerRate);
				setValue(`paytm_amount_${index}`, load.customerRate);

				setValue(`accountType_${index}`, organizationData.accountType || "");
				setValue(`depositType_${index}`, organizationData.depositType || "");
				setValue(`abaRoutingNumber_${index}`, organizationData.abaRoutingNumber || "");
				setValue(`accountNumber_${index}`, organizationData.accountNumber || "");
				setValue(`voidedCheck_${index}`, organizationData.voidedCheck || "");
			});
		} else {
			dispatch(setBackDropOpen(false));
		}
	}, [loads, customerData, organizationData]);

	const getActualLoad = (load) => {
		const actualLoadArr = loads.map((item) => {
			if (item._id === load._id) return item;
		});
		const actualLoad = actualLoadArr.filter((item) => item !== null && item !== undefined);
		return actualLoad[0];
	};

	const fileUpload = async (id, formData) => {
		const accessToken = localStorage.getItem(config.accessTokenName);
		try {
			await axios.put(`${config.apiBaseUrl}/load/${id}/upload-invoice`, formData, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
					"Content-Type": "multipart/form-data",
				},
			});
		} catch (error) {
			console.error("Error during file upload:", error);
			throw error; // Rethrow the error to handle it in the batch process
		}
	};

	const handleInvoiceDownload = async (loadsData) => {
		const promises = loadsData.map(async (load) => {
			try {
				const blob = await pdf(
					<Invoice load={load} userData={userData} loadApiData={getActualLoad(load)} />
				).toBlob();
				saveAs(blob, `load_invoice_${load.loadId}.pdf`);

				const formData = new FormData();
				formData.append("invoicedFile", blob, `load_invoice_${load.loadId}.pdf`);

				await fileUpload(load._id, formData);
				console.log("Download and upload successful for", load.loadId);
				return { success: true, loadId: load.loadId };
			} catch (error) {
				console.error("Error performing download and upload for", load.loadId, ":", error);
				return { success: false, loadId: load.loadId, error: error };
			}
		});

		// Wait for all promises to resolve
		const results = await Promise.allSettled(promises);
		results.forEach((result) => {
			if (result.status === "fulfilled" && result.value.success) {
				console.log(`Successfully processed ${result.value.loadId}`);
			} else if (result.status === "rejected" || !result.value.success) {
				console.error(
					`Failed to process ${result.value.loadId}`,
					result.reason || result.value.error
				);
			}
		});
	};

	const transformData = (data) => {
		const keys = Object.keys(data);
		let separatedCount = 0;
		const aloneKeys = [];
		const repeatedKeys = [];
		keys.forEach((key) => {
			const seps = key.split("_");
			const temp = parseInt(seps[seps.length - 1]);
			if (Number.isInteger(temp)) {
				if (separatedCount <= temp) {
					separatedCount++;
				}
				const newKey = seps.slice(0, -1).join("_");
				if (!repeatedKeys.includes(newKey)) repeatedKeys.push(newKey);
			} else {
				aloneKeys.push(key);
			}
		});

		let result = [];

		for (let i = 0; i <= separatedCount - 1; i++) {
			let newObj = {};
			repeatedKeys.forEach((key) => {
				newObj[key] = data[`${key}_${i}`];
			});
			aloneKeys.forEach((key) => {
				newObj[key] = data[key];
			});
			result.push(newObj);
		}

		return result;
	};

	const [triggerLoadsBackend] = useLazyGetDispatchedLoadsQuery();

	const onSubmit = async (data) => {
		dispatch(setBackDropOpen(true));
		const formatDate = (date) => date && date.format("MM/DD/YYYY, hh:mm A");

		// Prepare formatted dates
		const formattedDates = loads.reduce((acc, load, index) => {
			const dateKey = `lastDate_${index}`;
			acc[dateKey] = formatDate(data[dateKey]);
			return acc;
		}, {});

		// Prepare payloads
		const formData = loads.map((load, index) => ({
			id: load._id,
			payload: {
				brokerPaymentStatus: load.customer?.isApproved ? "Factored" : "Invoiced",
				brokerInvoicedInfo: {
					lastDate: formattedDates[`lastDate_${index}`],
				},
			},
		}));

		// Perform updates in parallel
		const updateLoads = async () => {
			const updatePromises = formData.map(
				(data) =>
					updateLoad(data)
						.unwrap()
						.catch((error) => ({ error, id: data.id })) // Handle errors within each promise
			);
			const results = await Promise.allSettled(updatePromises);
			results.forEach((result) => {
				if (result.status === "fulfilled" && !result.value.error) {
					console.log(`Successfully updated load ${result.value.id}`);
				} else {
					console.error(
						`Failed to update load ${result.value.id}:`,
						result.reason || result.value.error
					);
				}
			});
		};

		const currentTab = globalUtils.snakeCaseToCapitalize(loadsActiveFilter);
		await updateLoads();

		triggerLoads(lastLoadsQuery, false)
			.unwrap()
			.then(() => {
				dispatch(setBackDropOpen(false));
				setShowModal(false);
			});
		triggerLoadsCount("?type=broker");
		triggerTotalRate(`?paymentStatus=${currentTab}&type=broker`);
		setShowModalPaid(false);
		toast("Load payment statuses updated successfully!");
		setDeleteIds([]);

		triggerLoadsBackend(
			"?paymentStatus=Invoiced&page=1&rowsPerPage=15&orderBy=loadId&order=desc&type=broker&search=",
			false
		);
		triggerLoadsBackend(
			"?paymentStatus=Factored&page=1&rowsPerPage=15&orderBy=loadId&order=desc&type=broker&search=",
			false
		);
		triggerTotalRateBackend("?paymentStatus=Invoiced&type=broker");
		triggerTotalRateBackend("?paymentStatus=Factored&type=broker");

		handleInvoiceDownload(transformData(data), organizationData);
	};

	const handleClickSecondaryBtn = () => {
		for (let i = 0; i < loads.length; i++) {
			const lastDate = watch(`lastDate_${i}`);
			if (lastDate === null || lastDate === undefined) {
				setCurrentLoad({ index: i, ...loads[i] });
				setError(`lastDate_${i}`, {
					type: "required",
					message: "Overdue date is required!",
				});
				break;
			}
		}

		handleSubmit(onSubmit)();
	};

	const handleUseForAll = (isChecked, currentIndex) => {
		if (isChecked) {
			for (let i = 0; i < loads.length; i++) {
				const lastDate = watch(`lastDate_${currentIndex}`);
				if (i !== currentIndex) setValue(`lastDate_${i}`, lastDate);
			}
		}
	};

	return (
		<>
			<button onClick={() => setShowModal(true)}>Edit Invoices</button>
			<form onSubmit={handleSubmit(onSubmit)}>
				<MUIModal
					showModal={showModal}
					setShowModal={setShowModal}
					modalTitle={"Edit Invoices"}
					closeBtn="Cancel"
					secondaryBtnText={"Update And Create Invoices"}
					handleClickSecondaryBtn={handleClickSecondaryBtn}
					isSubmit={true}
					modalClassName="wd-80"
					modalBodyComponent={
						<>
							{loads.length > 0 ? (
								<ButtonGroup sx={{ mb: 2 }} variant="outlined" aria-label="outlined button group">
									{loads.map((load, index) => (
										<Button
											variant={
												currentLoad && currentLoad.index === index ? "contained" : "outlined"
											}
											key={index}
											onClick={() => setCurrentLoad({ index: index, ...load })}
										>
											{load.loadId}
										</Button>
									))}
								</ButtonGroup>
							) : (
								<p>No loads available.</p>
							)}
							{loads && currentLoad && (
								<div key={currentLoad._id}>
									<input type="hidden" {...register(`_id_${currentLoad.index}`)} />
									<Invoices
										setValue={setValue}
										register={register}
										errors={errors}
										watch={watch}
										control={control}
										load={currentLoad}
										index={currentLoad.index}
										handleUseForAll={handleUseForAll}
									/>
								</div>
							)}
						</>
					}
				/>
				<MUIModal
					showModal={showModalPaid}
					setShowModal={setShowModalPaid}
					modalTitle="Load Paid"
					modalClassName="wd-65"
					isFooter={false}
					modalBodyComponent={
						<LoadInvoice currentData={loads[0]} setShowModalPaid={setShowModalPaid} />
					} // Assuming one load for LoadInvoice
				/>
			</form>
		</>
	);
};

export default InvoicesSection;
